import { ReactElement } from 'react'
import styled from 'styled-components'

import { StopIndex } from 'components/Map/StopIndex'
import { LocationDetails } from 'features/RoutingProjects/components/LocationDetails'
import { getUniqueColor, rgbToHex } from 'utils/style'
import { IRoutingProjectDatasetLocation } from 'features/RoutingProjects/types'
import { DragIndicatorIcon } from 'components/Icons'

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

interface ILocationItemProps {
  location: IRoutingProjectDatasetLocation
  locationIndex: number
  routeIndex?: number | null
  draggable?: boolean
}

export const LocationItem = ({ location, locationIndex, routeIndex, draggable }: ILocationItemProps): ReactElement => {
  let color = '#28265D'
  let bgColor = '#E3E3E3'

  if (routeIndex) {
    color = getUniqueColor(routeIndex)
    bgColor = `${rgbToHex(color)}20`
  }

  return (
    <Container>
      {draggable && <DragIndicatorIcon />}
      <StopIndex color={color} bgColor={bgColor}>
        {locationIndex + 1}
      </StopIndex>
      <LocationDetails location={location} />
    </Container>
  )
}
